module.exports = __webpack_public_path__ + "media/images/icons/search-4ccdc04b673a681069e1bad3ae8d7b70.svg";